<div class="p-5">
  <p>{{ labels.ERROR_MESSAGE_PAGE }}</p>
  <a class="nav-top-link" href="/">
    <i class="">{{ labels.BACK_TO_HOME }}</i>
  </a>
</div>
